import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rrp-user-account-item-skeleton',
  templateUrl: './user-account-item-skeleton.component.html',
  styleUrls: ['./user-account-item-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAccountItemSkeletonComponent {}
